// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Features-styles___description--TrpW_::before {
  content: '\\A';
  white-space: pre;
}
.components-Features-styles___description--TrpW_ {
  font-size: 13px;
  color: #1b2432;
  font-weight: normal;
  min-width: 307px;
  line-height: 15px;
  max-width: 320px;
}
.components-Features-styles___paper--ahGnu {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
    margin-bottom: 30px;
    padding-bottom: 25px;
  }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf h2 {
      margin-bottom: 10px;
      font-weight: 600;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf .components-Features-styles___tableCell--rOKAN {
      font-size: 15px !important;
      color: #1b2432 !important;
      letter-spacing: 0;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf .components-Features-styles___tableCell--rOKAN:first-child {
        line-height: 13px;
        padding-bottom: 0 !important;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf .components-Features-styles___tableCell--rOKAN .components-Features-styles___description--TrpW_::before {
        content: '\\A';
        white-space: pre;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf .components-Features-styles___tableCell--rOKAN .components-Features-styles___description--TrpW_ {
        font-size: 13px;
        color: #1b2432;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf .components-Features-styles___tableRow--g2KbM {
      height: 68px !important;
      vertical-align: center;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___features--Gv7Cf .components-Features-styles___tableRow--g2KbM td:first-child {
        padding-left: 0 !important;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq {
    padding-bottom: 0;
  }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq h2 {
      margin-bottom: 10px;
      font-weight: 600 !important;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq td:first-child {
      padding-bottom: 30px !important;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN {
      font-size: 15px !important;
      color: #1b2432 !important;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN:first-child {
        line-height: 13px;
        padding-bottom: 25px;
        padding-top: 30px !important;
        font-weight: 600;
        padding-right: 0 !important;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN .components-Features-styles___description--TrpW_::before {
        content: '\\A';
        white-space: pre;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN .components-Features-styles___description--TrpW_ {
        font-size: 13px;
        color: #1b2432;
        font-weight: normal;
        min-width: 307px;
        line-height: 15px;
        overflow-wrap: break-word;
        white-space: normal;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN .components-Features-styles___descriptionReimburs--UTFu9::before {
        content: '\\A';
        white-space: pre;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN .components-Features-styles___descriptionReimburs--UTFu9 {
        font-size: 13px;
        color: #1b2432;
        font-weight: normal;
        max-width: 271px;
        line-height: 15px;
        overflow-wrap: break-word;
        white-space: normal;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN .components-Features-styles___descriptionFlightBooking--VB2bm::before {
        content: '\\A';
        white-space: pre;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableCell--rOKAN .components-Features-styles___descriptionFlightBooking--VB2bm {
        font-size: 13px;
        color: #1b2432;
        font-weight: normal;
        max-width: 100%;
        line-height: 15px;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___fraud--iWGdE {
      width: 270px;
      max-width: 270px;
      padding-right: 25px !important;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___fraudSelect--RH3JD {
      width: 330px;
      text-align: right;
      padding: 0 !important;
      width: 100px;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___inputWrapper--oTOxE div {
        min-width: 280px;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___inputWrapper--oTOxE .components-Features-styles___marginNormal--Doeg_ {
        width: 330px;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___recommended--CzhLU {
      background: rgba(18, 218, 159, 0.1);
      border: 1px solid #12da9f;
      border-radius: 4px;
      width: 105px !important;
      height: 24px;
      font-size: 13px;
      color: #1b2432;
      letter-spacing: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___recommendedItemContainer--tLvu0 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___recommendedItemFraud--LW0Et {
      margin-right: 45px;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableRow--g2KbM {
      height: 68px !important;
      vertical-align: center;
    }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableRow--g2KbM td:first-child {
        padding-left: 0 !important;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableRow--g2KbM:first-child {
        padding-bottom: 20px !important;
      }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq .components-Features-styles___tableRow--g2KbM:last-child .components-Features-styles___tableCell--rOKAN {
          border: none;
        }
.components-Features-styles___paper--ahGnu .components-Features-styles___expensesFeatures--fBXNq tr:last-child td {
        padding-bottom: 0 !important;
      }
.components-Features-styles___inputContainer--SJ4JG {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}
.components-Features-styles___inputWrapper--oTOxE {
  flex: 49% 0 1;
  padding: 8px 0 0;
}
.components-Features-styles___table--r0HJ7 {
  margin: 20px 0 0;
}
.components-Features-styles___tableHead--A8ay8 {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}
.components-Features-styles___tableRow--g2KbM {
  height: 68px !important;
}
.components-Features-styles___tableRow--g2KbM:last-child .components-Features-styles___tableCell--rOKAN {
      border: none;
    }
.components-Features-styles___tableRow--g2KbM td:first-child {
    padding-left: 0 !important;
  }
.components-Features-styles___tableCell--rOKAN {
  font-size: 15px !important;
  padding: 16px 56px 16px 24px !important;
}
.components-Features-styles___emptyData--LLKyy {
  padding: 24px 0;
}
.components-Features-styles___table--r0HJ7 {
  margin: 20px 0 0;
}
.components-Features-styles___tableHead--A8ay8 {
  color: #1b2432 !important;
  font-weight: 500 !important;
  font-size: 15px !important;
}
.components-Features-styles___tableRow--g2KbM {
  height: 68px !important;
}
.components-Features-styles___tableRow--g2KbM:last-child .components-Features-styles___tableCell--rOKAN {
      border: none;
    }
.components-Features-styles___tableRow--g2KbM.components-Features-styles___addNewTableRow--d3RxE {
    border-bottom: 1px solid rgba(224, 224, 224, 1);
  }
.components-Features-styles___tableRow--g2KbM td:first-child {
    padding-left: 0 !important;
  }
.components-Features-styles___tableCell--rOKAN {
  font-size: 15px !important;
  padding: 16px 30px 16px 24px !important;
}
.components-Features-styles___tableCell--rOKAN.components-Features-styles___buttonCell--reapT {
    text-align: right;
    padding: 0 !important;
    width: 100px;
  }
.components-Features-styles___tableCell--rOKAN.components-Features-styles___buttonCell--reapT button {
      padding-left: 0;
      padding-right: 0;
    }
.components-Features-styles___tableCell--rOKAN.components-Features-styles___inputTableCell--GyoR2 {
    padding: 16px 16px 16px 0 !important;
    width: 250px;
  }
.components-Features-styles___tableCell--rOKAN.components-Features-styles___inputTableCell--GyoR2 > div {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
.components-Features-styles___tableCell--rOKAN.components-Features-styles___buttonTableCell--vxgwk {
    padding: 16px 0 !important;
    text-align: right !important;
    width: 160px;
  }
.components-Features-styles___iOSBar--AK79s,
.components-Features-styles___iOSBarON--ZFy_m {
  border-radius: 35px !important;
  width: 72px !important;
  height: 32px !important;
  margin-top: -15px !important;
  background-color: #6d717a !important;
  opacity: 1 !important;
  margin-left: -32px !important;
}
.components-Features-styles___iOSBar--AK79s:before {
  content: attr(title) 'OFF';
  color: white !important;
  position: relative !important;
  top: 7px !important;
  right: 9px !important;
  font-size: 15px !important;
  letter-spacing: 0 !important;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}
.components-Features-styles___iOSBarON--ZFy_m:before {
  content: attr(title) 'ON';
  color: white !important;
  position: relative !important;
  top: 7px !important;
  left: -38px !important;
  font-size: 15px !important;
  letter-spacing: 0 !important;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
}
.components-Features-styles___iOSIcon--EzfA5 {
  width: 24px !important;
  height: 24px !important;
  background-color: white !important;
}
.components-Features-styles___iOSIconChecked--XGskT {
  boxshadow: theme.shadows[1] !important;
  content: attr(title) 'ON' !important;
}
.components-Features-styles___iOSSwitchBase--N0sGG {
  width: 31px !important;
}
.components-Features-styles___iOSSwitchBase--N0sGG .components-Features-styles___iOSChecked--qL1H3 {
    color: green;
  }
.components-Features-styles___iOSSwitchBase--N0sGG .components-Features-styles___iOSChecked--qL1H3 + \$iOSBar {
      background-color: red;
    }
.components-Features-styles___iOSChecked--qL1H3 {
  transform: translateX(35px) !important;
  width: 38px !important;
}
.components-Features-styles___iOSChecked--qL1H3 + .components-Features-styles___iOSBarON--ZFy_m {
    opacity: 1 !important;
    background-color: #318afb !important;
    border: none !important;
  }
.components-Features-styles___iOSChecked--qL1H3.components-Features-styles___iOSBarON--ZFy_m {
    background-color: '#318AFB' !important;
  }
.components-Features-styles___colorPrimary--W4pgm {
  color: #318afb;
  width: 31px;
  margin-top: 1px !important;
}
.components-Features-styles___loaderWrapper--XYUuz {
  position: relative !important;
}
.components-Features-styles___pageWrapper--yKCwh {
  border: 0px !important;
}
.components-Features-styles___loading--AVVqS {
  background-color: #f6f6f7 !important;

  pointer-events: none;
}
.components-Features-styles___loading--AVVqS .components-Features-styles___features--Gv7Cf {
    background-color: #f6f6f7 !important;
    pointer-events: none;
  }
.components-Features-styles___labelName--GTwY7 {
  padding-left: 0;
}
.components-Features-styles___bankAccount--hgxs9 {
  text-align: left !important;
  cursor: pointer;
}
.components-Features-styles___bankAccount--hgxs9 svg {
    margin-right: 14px;
  }
.components-Features-styles___bankAccountExists--nLFgO {
  text-align: left !important;
}
.components-Features-styles___bankAccountExists--nLFgO svg {
    margin-right: 14px;
  }
.components-Features-styles___bankAccountContent--ybbBO {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  font-size: 15px;
  color: #1b2432;
  letter-spacing: 0;
  font-weight: 600;
  padding-left: 18px;
}
.components-Features-styles___bankAccountContainer--xARPu {
  display: flex;
  justify-content: space-between;
}
.components-Features-styles___bankAccountContainer--xARPu .components-Features-styles___editBankAccount--kH62v {
    font-size: 15px;
    color: #318afb !important;
    letter-spacing: 0;
    text-align: right;
    cursor: pointer;
  }
.components-Features-styles___tableAdvancedFlightRow--DSeWM {
  padding-top: 30px;
}
.components-Features-styles___tableAdvancedFlightRow--DSeWM td:first-child {
    padding-top: 0 !important;
  }
.components-Features-styles___tableAdvancedFlightRow--DSeWM .components-Features-styles___tableAdvancedFlightRowHeader--ziHm5 {
    font-size: 15px;
    color: #1b2432;
  }
.components-Features-styles___tableAdvancedFlightRow--DSeWM .components-Features-styles___tableAdvancedFlightRowDescription--qI8Iy {
    padding-top: 10px;
    font-size: 13px;
    color: #1b2432;
    font-weight: normal;
    line-height: 15px;
  }
.components-Features-styles___tableAdvancedFlightRowValue--Ms3h9 {
  padding-top: 0 !important;
}
.components-Features-styles___tableRowFlight--TaiY6 {
  margin-bottom: 20px;
}
.components-Features-styles___dialogBoxUpdate--Gd0mN {
  min-width: 700px;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___title--nPrhK {
    font-size: 29px;
    color: #1b2432;
    background-color: #fff;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 1 0 auto;
    padding: 32px 32px 0;
    padding-bottom: 12px;
  }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___title--nPrhK .components-Features-styles___closeIcon--TUflj {
      position: absolute;
      top: 18px;
      right: 18px;
    }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___title--nPrhK .components-Features-styles___closeIcon--TUflj .components-Features-styles___svg--fZt_M {
        font-size: 26px;
      }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___popupBody--jmhid {
    min-width: 700px;
    padding: 32px;
    padding-top: 0;
  }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___popupBody--jmhid td {
      padding-bottom: 0 !important;
      padding-top: 0 !important;
    }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___confirmationPopupButton--TKqZE {
    border-top: 1px solid rgba(224, 224, 224, 1);
    margin: 32px;
    margin-top: 0;
    padding-top: 32px;
    display: flex;
    justify-content: flex-end;
  }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___confirmationPopupButton--TKqZE button {
      background: #318afb;
      border-radius: 6px;
      width: 200px;
      height: 52px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: 'Roboto';
      font-size: 17px;
      color: #ffffff;
      letter-spacing: 0;
    }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___confirmationPopupButton--TKqZE button:disabled {
      opacity: 0.12 !important;
    }
.components-Features-styles___dialogBoxUpdate--Gd0mN td {
    border-bottom: none !important;
  }
.components-Features-styles___dialogBoxUpdate--Gd0mN .components-Features-styles___inputWrapper--oTOxE {
    max-width: 320px;
    flex: 49% 0 1;
    padding: 0;
  }
.components-Features-styles___disabled--fOigS + .components-Features-styles___iOSBarON--ZFy_m,
.components-Features-styles___disabled--fOigS + .components-Features-styles___iOSBar--AK79s {
  background-color: #e0e2e6 !important;
  opacity: 1 !important;
}
`, "",{"version":3,"sources":["webpack://./components/Features/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAgLlB;AA9KE;IACE,+CAA+C;IAC/C,mBAAmB;IACnB,oBAAoB;EAmCtB;AAjCE;MACE,mBAAmB;MACnB,gBAAgB;IAClB;AAEA;MACE,0BAA0B;MAC1B,yBAAyB;MACzB,iBAAiB;IAenB;AAbE;QACE,iBAAiB;QACjB,4BAA4B;MAC9B;AAEA;QACE,aAAa;QACb,gBAAgB;MAClB;AACA;QACE,eAAe;QACf,cAAc;MAChB;AAGF;MACE,uBAAuB;MACvB,sBAAsB;IAKxB;AAHE;QACE,0BAA0B;MAC5B;AAIJ;IACE,iBAAiB;EAoInB;AAlIE;MACE,mBAAmB;MACnB,2BAA2B;IAC7B;AAEA;MACE,+BAA+B;IACjC;AACA;MACE,0BAA0B;MAC1B,yBAAyB;IAmD3B;AAjDE;QACE,iBAAiB;QACjB,oBAAoB;QACpB,4BAA4B;QAC5B,gBAAgB;QAChB,2BAA2B;MAC7B;AAEA;QACE,aAAa;QACb,gBAAgB;MAClB;AACA;QACE,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;MACrB;AAEA;QACE,aAAa;QACb,gBAAgB;MAClB;AAEA;QACE,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,gBAAgB;QAChB,iBAAiB;QACjB,yBAAyB;QACzB,mBAAmB;MACrB;AAEA;QACE,aAAa;QACb,gBAAgB;MAClB;AAEA;QACE,eAAe;QACf,cAAc;QACd,mBAAmB;QACnB,eAAe;QACf,iBAAiB;MACnB;AAGF;MACE,YAAY;MACZ,gBAAgB;MAChB,8BAA8B;IAChC;AACA;MACE,YAAY;MACZ,iBAAiB;MACjB,qBAAqB;MACrB,YAAY;IACd;AAGE;QACE,gBAAgB;MAClB;AACA;QACE,YAAY;MACd;AAGF;MACE,mCAAmC;MACnC,yBAAyB;MACzB,kBAAkB;MAClB,uBAAuB;MACvB,YAAY;MACZ,eAAe;MACf,cAAc;MACd,iBAAiB;MACjB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;IACzB;AAEA;MACE,aAAa;MACb,8BAA8B;MAC9B,mBAAmB;MACnB,WAAW;IACb;AACA;MACE,kBAAkB;IACpB;AACA;MACE,uBAAuB;MACvB,sBAAsB;IAexB;AAbE;QACE,0BAA0B;MAC5B;AAEA;QACE,+BAA+B;MACjC;AAGE;UACE,YAAY;QACd;AAIF;QACE,4BAA4B;MAC9B;AAKN;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,oBAAoB;AACtB;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;AAEA;EACE,uBAAuB;AAWzB;AARI;MACE,YAAY;IACd;AAGF;IACE,0BAA0B;EAC5B;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;AAEA;EACE,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;AAC5B;AAEA;EACE,uBAAuB;AAezB;AAZI;MACE,YAAY;IACd;AAGF;IACE,+CAA+C;EACjD;AAEA;IACE,0BAA0B;EAC5B;AAGF;EACE,0BAA0B;EAC1B,uCAAuC;AA4BzC;AA1BE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,YAAY;EAMd;AAJE;MACE,eAAe;MACf,gBAAgB;IAClB;AAGF;IACE,oCAAoC;IACpC,YAAY;EAMd;AAJE;MACE,wBAAwB;MACxB,2BAA2B;IAC7B;AAGF;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,YAAY;EACd;AAGF;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,oCAAoC;EACpC,qBAAqB;EACrB,6BAA6B;AAC/B;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,4BAA4B;EAC5B,uDAAuD;AACzD;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;EAC1B,4BAA4B;EAC5B,uDAAuD;AACzD;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;AACpC;AACA;EACE,sCAAsC;EACtC,oCAAoC;AACtC;AAEA;EACE,sBAAsB;AAOxB;AANE;IACE,YAAY;EAId;AAHE;MACE,qBAAqB;IACvB;AAIJ;EACE,sCAAsC;EACtC,sBAAsB;AAMxB;AALE;IACE,qBAAqB;IACrB,oCAAoC;IACpC,uBAAuB;EACzB;AAIA;IACE,sCAAsC;EACxC;AAGF;EACE,cAAc;EACd,WAAW;EACX,0BAA0B;AAC5B;AAEA;EACE,6BAA6B;AAC/B;AAEA;EACE,sBAAsB;AACxB;AAEA;EACE,oCAAoC;;EAEpC,oBAAoB;AAMtB;AAJE;IACE,oCAAoC;IACpC,oBAAoB;EACtB;AAGF;EACE,eAAe;AACjB;AAEA;EACE,2BAA2B;EAC3B,eAAe;AAIjB;AAHE;IACE,kBAAkB;EACpB;AAGF;EACE,2BAA2B;AAI7B;AAHE;IACE,kBAAkB;EACpB;AAGF;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,uDAAuD;EACvD,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AAEA;EACE,aAAa;EACb,8BAA8B;AAShC;AAPE;IACE,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;AAGF;EACE,iBAAiB;AAiBnB;AAhBE;IACE,yBAAyB;EAC3B;AAEA;IACE,eAAe;IACf,cAAc;EAChB;AAEA;IACE,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,iBAAiB;EACnB;AAGF;EACE,yBAAyB;AAC3B;AAEA;EACE,mBAAmB;AACrB;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AAsEzB;AApEE;IACE,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,oBAAoB;IACpB,oBAAoB;EAWtB;AATE;MACE,kBAAkB;MAClB,SAAS;MACT,WAAW;IAKb;AAHE;QACE,eAAe;MACjB;AAIJ;IACE,gBAAgB;IAChB,aAAa;IACb,cAAc;EAMhB;AAJE;MACE,4BAA4B;MAC5B,yBAAyB;IAC3B;AAGF;IACE,4CAA4C;IAC5C,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,yBAAyB;EAkB3B;AAhBE;MACE,mBAAmB;MACnB,kBAAkB;MAClB,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB;MACnB,qBAAqB;MACrB,eAAe;MACf,cAAc;MACd,iBAAiB;IACnB;AACA;MACE,wBAAwB;IAC1B;AAGF;IACE,8BAA8B;EAChC;AAEA;IACE,gBAAgB;IAChB,aAAa;IACb,UAAU;EACZ;AAGF;;EAEE,oCAAoC;EACpC,qBAAqB;AACvB","sourcesContent":[".description::before {\n  content: '\\A';\n  white-space: pre;\n}\n.description {\n  font-size: 13px;\n  color: #1b2432;\n  font-weight: normal;\n  min-width: 307px;\n  line-height: 15px;\n  max-width: 320px;\n}\n\n.paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n\n  .features {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n    margin-bottom: 30px;\n    padding-bottom: 25px;\n\n    h2 {\n      margin-bottom: 10px;\n      font-weight: 600;\n    }\n\n    .tableCell {\n      font-size: 15px !important;\n      color: #1b2432 !important;\n      letter-spacing: 0;\n\n      &:first-child {\n        line-height: 13px;\n        padding-bottom: 0 !important;\n      }\n\n      .description::before {\n        content: '\\A';\n        white-space: pre;\n      }\n      .description {\n        font-size: 13px;\n        color: #1b2432;\n      }\n    }\n\n    .tableRow {\n      height: 68px !important;\n      vertical-align: center;\n\n      td:first-child {\n        padding-left: 0 !important;\n      }\n    }\n  }\n\n  .expensesFeatures {\n    padding-bottom: 0;\n\n    h2 {\n      margin-bottom: 10px;\n      font-weight: 600 !important;\n    }\n\n    td:first-child {\n      padding-bottom: 30px !important;\n    }\n    .tableCell {\n      font-size: 15px !important;\n      color: #1b2432 !important;\n\n      &:first-child {\n        line-height: 13px;\n        padding-bottom: 25px;\n        padding-top: 30px !important;\n        font-weight: 600;\n        padding-right: 0 !important;\n      }\n\n      .description::before {\n        content: '\\A';\n        white-space: pre;\n      }\n      .description {\n        font-size: 13px;\n        color: #1b2432;\n        font-weight: normal;\n        min-width: 307px;\n        line-height: 15px;\n        overflow-wrap: break-word;\n        white-space: normal;\n      }\n\n      .descriptionReimburs::before {\n        content: '\\A';\n        white-space: pre;\n      }\n\n      .descriptionReimburs {\n        font-size: 13px;\n        color: #1b2432;\n        font-weight: normal;\n        max-width: 271px;\n        line-height: 15px;\n        overflow-wrap: break-word;\n        white-space: normal;\n      }\n\n      .descriptionFlightBooking::before {\n        content: '\\A';\n        white-space: pre;\n      }\n\n      .descriptionFlightBooking {\n        font-size: 13px;\n        color: #1b2432;\n        font-weight: normal;\n        max-width: 100%;\n        line-height: 15px;\n      }\n    }\n\n    .fraud {\n      width: 270px;\n      max-width: 270px;\n      padding-right: 25px !important;\n    }\n    .fraudSelect {\n      width: 330px;\n      text-align: right;\n      padding: 0 !important;\n      width: 100px;\n    }\n\n    .inputWrapper {\n      div {\n        min-width: 280px;\n      }\n      .marginNormal {\n        width: 330px;\n      }\n    }\n\n    .recommended {\n      background: rgba(18, 218, 159, 0.1);\n      border: 1px solid #12da9f;\n      border-radius: 4px;\n      width: 105px !important;\n      height: 24px;\n      font-size: 13px;\n      color: #1b2432;\n      letter-spacing: 0;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n\n    .recommendedItemContainer {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n    }\n    .recommendedItemFraud {\n      margin-right: 45px;\n    }\n    .tableRow {\n      height: 68px !important;\n      vertical-align: center;\n\n      td:first-child {\n        padding-left: 0 !important;\n      }\n\n      &:first-child {\n        padding-bottom: 20px !important;\n      }\n\n      &:last-child {\n        .tableCell {\n          border: none;\n        }\n      }\n    }\n    tr:last-child {\n      td {\n        padding-bottom: 0 !important;\n      }\n    }\n  }\n}\n\n.inputContainer {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding-bottom: 32px;\n}\n\n.inputWrapper {\n  flex: 49% 0 1;\n  padding: 8px 0 0;\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  td:first-child {\n    padding-left: 0 !important;\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 56px 16px 24px !important;\n}\n\n.emptyData {\n  padding: 24px 0;\n}\n\n.table {\n  margin: 20px 0 0;\n}\n\n.tableHead {\n  color: #1b2432 !important;\n  font-weight: 500 !important;\n  font-size: 15px !important;\n}\n\n.tableRow {\n  height: 68px !important;\n\n  &:last-child {\n    .tableCell {\n      border: none;\n    }\n  }\n\n  &.addNewTableRow {\n    border-bottom: 1px solid rgba(224, 224, 224, 1);\n  }\n\n  td:first-child {\n    padding-left: 0 !important;\n  }\n}\n\n.tableCell {\n  font-size: 15px !important;\n  padding: 16px 30px 16px 24px !important;\n\n  &.buttonCell {\n    text-align: right;\n    padding: 0 !important;\n    width: 100px;\n\n    button {\n      padding-left: 0;\n      padding-right: 0;\n    }\n  }\n\n  &.inputTableCell {\n    padding: 16px 16px 16px 0 !important;\n    width: 250px;\n\n    > div {\n      margin-top: 0 !important;\n      margin-bottom: 0 !important;\n    }\n  }\n\n  &.buttonTableCell {\n    padding: 16px 0 !important;\n    text-align: right !important;\n    width: 160px;\n  }\n}\n\n.iOSBar,\n.iOSBarON {\n  border-radius: 35px !important;\n  width: 72px !important;\n  height: 32px !important;\n  margin-top: -15px !important;\n  background-color: #6d717a !important;\n  opacity: 1 !important;\n  margin-left: -32px !important;\n}\n\n.iOSBar:before {\n  content: attr(title) 'OFF';\n  color: white !important;\n  position: relative !important;\n  top: 7px !important;\n  right: 9px !important;\n  font-size: 15px !important;\n  letter-spacing: 0 !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.iOSBarON:before {\n  content: attr(title) 'ON';\n  color: white !important;\n  position: relative !important;\n  top: 7px !important;\n  left: -38px !important;\n  font-size: 15px !important;\n  letter-spacing: 0 !important;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n}\n\n.iOSIcon {\n  width: 24px !important;\n  height: 24px !important;\n  background-color: white !important;\n}\n.iOSIconChecked {\n  boxshadow: theme.shadows[1] !important;\n  content: attr(title) 'ON' !important;\n}\n\n.iOSSwitchBase {\n  width: 31px !important;\n  & .iOSChecked {\n    color: green;\n    & + $iOSBar {\n      background-color: red;\n    }\n  }\n}\n\n.iOSChecked {\n  transform: translateX(35px) !important;\n  width: 38px !important;\n  & + .iOSBarON {\n    opacity: 1 !important;\n    background-color: #318afb !important;\n    border: none !important;\n  }\n}\n\n.iOSChecked {\n  &.iOSBarON {\n    background-color: '#318AFB' !important;\n  }\n}\n\n.colorPrimary {\n  color: #318afb;\n  width: 31px;\n  margin-top: 1px !important;\n}\n\n.loaderWrapper {\n  position: relative !important;\n}\n\n.pageWrapper {\n  border: 0px !important;\n}\n\n.loading {\n  background-color: #f6f6f7 !important;\n\n  pointer-events: none;\n\n  .features {\n    background-color: #f6f6f7 !important;\n    pointer-events: none;\n  }\n}\n\n.labelName {\n  padding-left: 0;\n}\n\n.bankAccount {\n  text-align: left !important;\n  cursor: pointer;\n  svg {\n    margin-right: 14px;\n  }\n}\n\n.bankAccountExists {\n  text-align: left !important;\n  svg {\n    margin-right: 14px;\n  }\n}\n\n.bankAccountContent {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n  font-size: 15px;\n  color: #1b2432;\n  letter-spacing: 0;\n  font-weight: 600;\n  padding-left: 18px;\n}\n\n.bankAccountContainer {\n  display: flex;\n  justify-content: space-between;\n\n  .editBankAccount {\n    font-size: 15px;\n    color: #318afb !important;\n    letter-spacing: 0;\n    text-align: right;\n    cursor: pointer;\n  }\n}\n\n.tableAdvancedFlightRow {\n  padding-top: 30px;\n  td:first-child {\n    padding-top: 0 !important;\n  }\n\n  .tableAdvancedFlightRowHeader {\n    font-size: 15px;\n    color: #1b2432;\n  }\n\n  .tableAdvancedFlightRowDescription {\n    padding-top: 10px;\n    font-size: 13px;\n    color: #1b2432;\n    font-weight: normal;\n    line-height: 15px;\n  }\n}\n\n.tableAdvancedFlightRowValue {\n  padding-top: 0 !important;\n}\n\n.tableRowFlight {\n  margin-bottom: 20px;\n}\n\n.dialogBoxUpdate {\n  min-width: 700px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n\n  .title {\n    font-size: 29px;\n    color: #1b2432;\n    background-color: #fff;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    flex: 1 0 auto;\n    padding: 32px 32px 0;\n    padding-bottom: 12px;\n\n    .closeIcon {\n      position: absolute;\n      top: 18px;\n      right: 18px;\n\n      .svg {\n        font-size: 26px;\n      }\n    }\n  }\n\n  .popupBody {\n    min-width: 700px;\n    padding: 32px;\n    padding-top: 0;\n\n    td {\n      padding-bottom: 0 !important;\n      padding-top: 0 !important;\n    }\n  }\n\n  .confirmationPopupButton {\n    border-top: 1px solid rgba(224, 224, 224, 1);\n    margin: 32px;\n    margin-top: 0;\n    padding-top: 32px;\n    display: flex;\n    justify-content: flex-end;\n\n    button {\n      background: #318afb;\n      border-radius: 6px;\n      width: 200px;\n      height: 52px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      font-family: 'Roboto';\n      font-size: 17px;\n      color: #ffffff;\n      letter-spacing: 0;\n    }\n    button:disabled {\n      opacity: 0.12 !important;\n    }\n  }\n\n  td {\n    border-bottom: none !important;\n  }\n\n  .inputWrapper {\n    max-width: 320px;\n    flex: 49% 0 1;\n    padding: 0;\n  }\n}\n\n.disabled + .iOSBarON,\n.disabled + .iOSBar {\n  background-color: #e0e2e6 !important;\n  opacity: 1 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `components-Features-styles___description--TrpW_`,
	"paper": `components-Features-styles___paper--ahGnu`,
	"features": `components-Features-styles___features--Gv7Cf`,
	"tableCell": `components-Features-styles___tableCell--rOKAN`,
	"tableRow": `components-Features-styles___tableRow--g2KbM`,
	"expensesFeatures": `components-Features-styles___expensesFeatures--fBXNq`,
	"descriptionReimburs": `components-Features-styles___descriptionReimburs--UTFu9`,
	"descriptionFlightBooking": `components-Features-styles___descriptionFlightBooking--VB2bm`,
	"fraud": `components-Features-styles___fraud--iWGdE`,
	"fraudSelect": `components-Features-styles___fraudSelect--RH3JD`,
	"inputWrapper": `components-Features-styles___inputWrapper--oTOxE`,
	"marginNormal": `components-Features-styles___marginNormal--Doeg_`,
	"recommended": `components-Features-styles___recommended--CzhLU`,
	"recommendedItemContainer": `components-Features-styles___recommendedItemContainer--tLvu0`,
	"recommendedItemFraud": `components-Features-styles___recommendedItemFraud--LW0Et`,
	"inputContainer": `components-Features-styles___inputContainer--SJ4JG`,
	"table": `components-Features-styles___table--r0HJ7`,
	"tableHead": `components-Features-styles___tableHead--A8ay8`,
	"emptyData": `components-Features-styles___emptyData--LLKyy`,
	"addNewTableRow": `components-Features-styles___addNewTableRow--d3RxE`,
	"buttonCell": `components-Features-styles___buttonCell--reapT`,
	"inputTableCell": `components-Features-styles___inputTableCell--GyoR2`,
	"buttonTableCell": `components-Features-styles___buttonTableCell--vxgwk`,
	"iOsBar": `components-Features-styles___iOSBar--AK79s`,
	"iOsBarOn": `components-Features-styles___iOSBarON--ZFy_m`,
	"iOsIcon": `components-Features-styles___iOSIcon--EzfA5`,
	"iOsIconChecked": `components-Features-styles___iOSIconChecked--XGskT`,
	"iOsSwitchBase": `components-Features-styles___iOSSwitchBase--N0sGG`,
	"iOsChecked": `components-Features-styles___iOSChecked--qL1H3`,
	"colorPrimary": `components-Features-styles___colorPrimary--W4pgm`,
	"loaderWrapper": `components-Features-styles___loaderWrapper--XYUuz`,
	"pageWrapper": `components-Features-styles___pageWrapper--yKCwh`,
	"loading": `components-Features-styles___loading--AVVqS`,
	"labelName": `components-Features-styles___labelName--GTwY7`,
	"bankAccount": `components-Features-styles___bankAccount--hgxs9`,
	"bankAccountExists": `components-Features-styles___bankAccountExists--nLFgO`,
	"bankAccountContent": `components-Features-styles___bankAccountContent--ybbBO`,
	"bankAccountContainer": `components-Features-styles___bankAccountContainer--xARPu`,
	"editBankAccount": `components-Features-styles___editBankAccount--kH62v`,
	"tableAdvancedFlightRow": `components-Features-styles___tableAdvancedFlightRow--DSeWM`,
	"tableAdvancedFlightRowHeader": `components-Features-styles___tableAdvancedFlightRowHeader--ziHm5`,
	"tableAdvancedFlightRowDescription": `components-Features-styles___tableAdvancedFlightRowDescription--qI8Iy`,
	"tableAdvancedFlightRowValue": `components-Features-styles___tableAdvancedFlightRowValue--Ms3h9`,
	"tableRowFlight": `components-Features-styles___tableRowFlight--TaiY6`,
	"dialogBoxUpdate": `components-Features-styles___dialogBoxUpdate--Gd0mN`,
	"title": `components-Features-styles___title--nPrhK`,
	"closeIcon": `components-Features-styles___closeIcon--TUflj`,
	"svg": `components-Features-styles___svg--fZt_M`,
	"popupBody": `components-Features-styles___popupBody--jmhid`,
	"confirmationPopupButton": `components-Features-styles___confirmationPopupButton--TKqZE`,
	"disabled": `components-Features-styles___disabled--fOigS`
};
module.exports = ___CSS_LOADER_EXPORT___;
